__turbopack_context__.v({
  "copy": "CoverSlide-module-scss-module__8iVXea__copy",
  "eyebrow": "CoverSlide-module-scss-module__8iVXea__eyebrow",
  "headline": "CoverSlide-module-scss-module__8iVXea__headline",
  "image": "CoverSlide-module-scss-module__8iVXea__image",
  "inner": "CoverSlide-module-scss-module__8iVXea__inner",
  "root": "CoverSlide-module-scss-module__8iVXea__root",
  "theme--makers-reserve": "CoverSlide-module-scss-module__8iVXea__theme--makers-reserve",
});
